import React from "react";
const Home = () => {
  return (
    <div id="home" className="   ">
      <div className=" h-screen flex  pb-20 sm:pb-0 items-center sm:h-[30rem] sm:flex sm:items-center sm:justify-center">
        <div className="text-center md:text-start">
          <div className="text-5xl p-5 sm:p-0  sm:text-6xl ">
          <h1 className="">
            Hi, I'm Roderick Ferrer
          </h1>
          </div>
          <div className="flex justify-center pt-5 ">
            <div className="  flex items-center gap-2 p-2   ">
              <a
                href="https://www.linkedin.com/in/roderickferrer/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className=" w-10 h-10 lg:w-7 lg:h-7 rounded-md"
                  src="https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/linkedin/linkedin-plain.svg"
                  alt=""
                />
              </a>
              <a
                href="https://github.com/DEREKFERRER"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="w-10 h-10 lg:w-7 lg:h-7 rounded-md"
                  src="https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/github/github-original.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
        </div>
     
   
    </div>
  );
};

export default Home;
